package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Turkmenistan Flag (20x15dp)
 *
 * - ISO Alpha-2: TM
 * - ISO Alpha-3: TKM
 * - ISO Numeric: 795
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Turkmenistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Turkmenistan:TM:TKM:795:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF29C470)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(1.25f, -0.202f)
                horizontalLineToRelative(6.25f)
                verticalLineToRelative(16.452f)
                horizontalLineToRelative(-6.25f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(1.25f, -0.202f)
                horizontalLineToRelative(6.25f)
                verticalLineToRelative(16.452f)
                horizontalLineToRelative(-6.25f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(1.622f, 0.566f)
                lineTo(1.281f, 1.005f)
                lineTo(1.25f, 0.974f)
                lineTo(1.581f, 0.549f)
                verticalLineTo(0.463f)
                lineTo(1.582f, 0.455f)
                lineTo(1.621f, 0.337f)
                lineTo(1.597f, 0.295f)
                lineTo(1.402f, 0.491f)
                lineTo(1.778f, -0.096f)
                verticalLineTo(0.105f)
                lineTo(1.851f, 0.17f)
                lineTo(2.023f, -0.132f)
                lineTo(1.85f, -0.422f)
                lineTo(1.725f, -0.326f)
                lineTo(1.776f, -0.224f)
                lineTo(1.741f, -0.2f)
                lineTo(1.459f, -0.672f)
                lineTo(1.639f, -0.549f)
                lineTo(1.67f, -0.595f)
                lineTo(1.498f, -0.771f)
                lineTo(1.574f, -0.854f)
                lineTo(1.323f, -1.222f)
                lineTo(1.355f, -1.25f)
                lineTo(1.629f, -0.85f)
                lineTo(1.558f, -0.772f)
                lineTo(1.726f, -0.601f)
                lineTo(1.649f, -0.488f)
                lineTo(1.597f, -0.524f)
                lineTo(1.695f, -0.359f)
                lineTo(1.861f, -0.487f)
                lineTo(2.072f, -0.132f)
                lineTo(1.861f, 0.238f)
                lineTo(1.738f, 0.127f)
                verticalLineTo(0.047f)
                lineTo(1.614f, 0.239f)
                lineTo(1.666f, 0.331f)
                lineTo(1.622f, 0.467f)
                verticalLineTo(0.566f)
                close()
                moveTo(1.281f, 4.144f)
                lineTo(1.622f, 3.705f)
                verticalLineTo(3.607f)
                lineTo(1.666f, 3.47f)
                lineTo(1.614f, 3.379f)
                lineTo(1.738f, 3.186f)
                verticalLineTo(3.266f)
                lineTo(1.861f, 3.377f)
                lineTo(2.072f, 3.007f)
                lineTo(1.861f, 2.653f)
                lineTo(1.695f, 2.78f)
                lineTo(1.597f, 2.616f)
                lineTo(1.649f, 2.651f)
                lineTo(1.726f, 2.539f)
                lineTo(1.558f, 2.367f)
                lineTo(1.629f, 2.289f)
                lineTo(1.355f, 1.889f)
                lineTo(1.323f, 1.918f)
                lineTo(1.574f, 2.285f)
                lineTo(1.498f, 2.369f)
                lineTo(1.67f, 2.544f)
                lineTo(1.639f, 2.59f)
                lineTo(1.459f, 2.467f)
                lineTo(1.741f, 2.939f)
                lineTo(1.776f, 2.915f)
                lineTo(1.725f, 2.813f)
                lineTo(1.85f, 2.717f)
                lineTo(2.023f, 3.007f)
                lineTo(1.851f, 3.309f)
                lineTo(1.778f, 3.244f)
                verticalLineTo(3.044f)
                lineTo(1.402f, 3.63f)
                lineTo(1.597f, 3.435f)
                lineTo(1.621f, 3.476f)
                lineTo(1.582f, 3.595f)
                lineTo(1.581f, 3.603f)
                verticalLineTo(3.688f)
                lineTo(1.25f, 4.113f)
                lineTo(1.281f, 4.144f)
                close()
                moveTo(1.622f, 6.568f)
                lineTo(1.281f, 7.006f)
                lineTo(1.25f, 6.976f)
                lineTo(1.581f, 6.55f)
                verticalLineTo(6.465f)
                lineTo(1.582f, 6.457f)
                lineTo(1.621f, 6.338f)
                lineTo(1.597f, 6.297f)
                lineTo(1.402f, 6.492f)
                lineTo(1.778f, 5.906f)
                verticalLineTo(6.106f)
                lineTo(1.851f, 6.172f)
                lineTo(2.023f, 5.87f)
                lineTo(1.85f, 5.579f)
                lineTo(1.725f, 5.675f)
                lineTo(1.776f, 5.777f)
                lineTo(1.741f, 5.801f)
                lineTo(1.459f, 5.329f)
                lineTo(1.639f, 5.452f)
                lineTo(1.67f, 5.406f)
                lineTo(1.498f, 5.231f)
                lineTo(1.574f, 5.147f)
                lineTo(1.323f, 4.78f)
                lineTo(1.355f, 4.752f)
                lineTo(1.629f, 5.151f)
                lineTo(1.558f, 5.23f)
                lineTo(1.726f, 5.401f)
                lineTo(1.649f, 5.513f)
                lineTo(1.597f, 5.478f)
                lineTo(1.695f, 5.642f)
                lineTo(1.861f, 5.515f)
                lineTo(2.072f, 5.869f)
                lineTo(1.861f, 6.24f)
                lineTo(1.738f, 6.129f)
                verticalLineTo(6.049f)
                lineTo(1.614f, 6.241f)
                lineTo(1.666f, 6.333f)
                lineTo(1.622f, 6.469f)
                verticalLineTo(6.568f)
                close()
                moveTo(1.281f, 9.915f)
                lineTo(1.622f, 9.476f)
                verticalLineTo(9.377f)
                lineTo(1.666f, 9.241f)
                lineTo(1.614f, 9.149f)
                lineTo(1.738f, 8.957f)
                verticalLineTo(9.037f)
                lineTo(1.861f, 9.148f)
                lineTo(2.072f, 8.778f)
                lineTo(1.861f, 8.424f)
                lineTo(1.695f, 8.551f)
                lineTo(1.597f, 8.386f)
                lineTo(1.649f, 8.422f)
                lineTo(1.726f, 8.309f)
                lineTo(1.558f, 8.138f)
                lineTo(1.629f, 8.06f)
                lineTo(1.355f, 7.66f)
                lineTo(1.323f, 7.688f)
                lineTo(1.574f, 8.056f)
                lineTo(1.498f, 8.14f)
                lineTo(1.67f, 8.315f)
                lineTo(1.639f, 8.361f)
                lineTo(1.459f, 8.238f)
                lineTo(1.741f, 8.71f)
                lineTo(1.776f, 8.686f)
                lineTo(1.725f, 8.584f)
                lineTo(1.85f, 8.488f)
                lineTo(2.023f, 8.778f)
                lineTo(1.851f, 9.08f)
                lineTo(1.778f, 9.015f)
                verticalLineTo(8.815f)
                lineTo(1.402f, 9.401f)
                lineTo(1.597f, 9.206f)
                lineTo(1.621f, 9.247f)
                lineTo(1.582f, 9.365f)
                lineTo(1.581f, 9.373f)
                verticalLineTo(9.459f)
                lineTo(1.25f, 9.884f)
                lineTo(1.281f, 9.915f)
                close()
                moveTo(1.281f, 12.5f)
                lineTo(1.622f, 12.061f)
                verticalLineTo(11.963f)
                lineTo(1.666f, 11.826f)
                lineTo(1.614f, 11.735f)
                lineTo(1.738f, 11.542f)
                verticalLineTo(11.622f)
                lineTo(1.861f, 11.733f)
                lineTo(2.072f, 11.363f)
                lineTo(1.861f, 11.009f)
                lineTo(1.695f, 11.136f)
                lineTo(1.597f, 10.972f)
                lineTo(1.649f, 11.007f)
                lineTo(1.726f, 10.895f)
                lineTo(1.558f, 10.724f)
                lineTo(1.629f, 10.645f)
                lineTo(1.355f, 10.245f)
                lineTo(1.323f, 10.274f)
                lineTo(1.574f, 10.641f)
                lineTo(1.498f, 10.725f)
                lineTo(1.67f, 10.9f)
                lineTo(1.639f, 10.946f)
                lineTo(1.459f, 10.823f)
                lineTo(1.741f, 11.295f)
                lineTo(1.776f, 11.271f)
                lineTo(1.725f, 11.169f)
                lineTo(1.85f, 11.073f)
                lineTo(2.023f, 11.364f)
                lineTo(1.851f, 11.665f)
                lineTo(1.778f, 11.6f)
                verticalLineTo(11.4f)
                lineTo(1.402f, 11.986f)
                lineTo(1.597f, 11.791f)
                lineTo(1.621f, 11.832f)
                lineTo(1.582f, 11.951f)
                lineTo(1.581f, 11.959f)
                verticalLineTo(12.044f)
                lineTo(1.25f, 12.47f)
                lineTo(1.281f, 12.5f)
                close()
                moveTo(7.469f, 12.5f)
                lineTo(7.128f, 12.061f)
                verticalLineTo(11.963f)
                lineTo(7.084f, 11.826f)
                lineTo(7.136f, 11.735f)
                lineTo(7.012f, 11.542f)
                verticalLineTo(11.622f)
                lineTo(6.889f, 11.733f)
                lineTo(6.678f, 11.363f)
                lineTo(6.889f, 11.009f)
                lineTo(7.055f, 11.136f)
                lineTo(7.153f, 10.972f)
                lineTo(7.101f, 11.007f)
                lineTo(7.024f, 10.895f)
                lineTo(7.192f, 10.724f)
                lineTo(7.121f, 10.645f)
                lineTo(7.395f, 10.245f)
                lineTo(7.427f, 10.274f)
                lineTo(7.176f, 10.641f)
                lineTo(7.252f, 10.725f)
                lineTo(7.08f, 10.9f)
                lineTo(7.111f, 10.946f)
                lineTo(7.291f, 10.823f)
                lineTo(7.009f, 11.295f)
                lineTo(6.974f, 11.271f)
                lineTo(7.025f, 11.169f)
                lineTo(6.9f, 11.073f)
                lineTo(6.727f, 11.364f)
                lineTo(6.899f, 11.665f)
                lineTo(6.972f, 11.6f)
                verticalLineTo(11.4f)
                lineTo(7.348f, 11.986f)
                lineTo(7.153f, 11.791f)
                lineTo(7.129f, 11.832f)
                lineTo(7.168f, 11.951f)
                lineTo(7.169f, 11.959f)
                verticalLineTo(12.044f)
                lineTo(7.5f, 12.47f)
                lineTo(7.469f, 12.5f)
                close()
                moveTo(7.128f, 9.476f)
                lineTo(7.469f, 9.915f)
                lineTo(7.5f, 9.884f)
                lineTo(7.169f, 9.459f)
                verticalLineTo(9.373f)
                lineTo(7.168f, 9.365f)
                lineTo(7.129f, 9.247f)
                lineTo(7.153f, 9.206f)
                lineTo(7.348f, 9.401f)
                lineTo(6.972f, 8.815f)
                verticalLineTo(9.015f)
                lineTo(6.899f, 9.08f)
                lineTo(6.727f, 8.778f)
                lineTo(6.9f, 8.488f)
                lineTo(7.025f, 8.584f)
                lineTo(6.974f, 8.686f)
                lineTo(7.009f, 8.71f)
                lineTo(7.291f, 8.238f)
                lineTo(7.111f, 8.361f)
                lineTo(7.08f, 8.315f)
                lineTo(7.252f, 8.14f)
                lineTo(7.176f, 8.056f)
                lineTo(7.427f, 7.688f)
                lineTo(7.395f, 7.66f)
                lineTo(7.121f, 8.06f)
                lineTo(7.192f, 8.138f)
                lineTo(7.024f, 8.309f)
                lineTo(7.101f, 8.422f)
                lineTo(7.153f, 8.386f)
                lineTo(7.055f, 8.551f)
                lineTo(6.889f, 8.424f)
                lineTo(6.678f, 8.778f)
                lineTo(6.889f, 9.148f)
                lineTo(7.012f, 9.037f)
                verticalLineTo(8.957f)
                lineTo(7.136f, 9.149f)
                lineTo(7.084f, 9.241f)
                lineTo(7.128f, 9.377f)
                verticalLineTo(9.476f)
                close()
                moveTo(7.469f, 7.006f)
                lineTo(7.128f, 6.568f)
                verticalLineTo(6.469f)
                lineTo(7.084f, 6.333f)
                lineTo(7.136f, 6.241f)
                lineTo(7.012f, 6.049f)
                verticalLineTo(6.129f)
                lineTo(6.889f, 6.24f)
                lineTo(6.678f, 5.869f)
                lineTo(6.889f, 5.515f)
                lineTo(7.055f, 5.642f)
                lineTo(7.153f, 5.478f)
                lineTo(7.101f, 5.513f)
                lineTo(7.024f, 5.401f)
                lineTo(7.192f, 5.23f)
                lineTo(7.121f, 5.151f)
                lineTo(7.395f, 4.752f)
                lineTo(7.427f, 4.78f)
                lineTo(7.176f, 5.147f)
                lineTo(7.252f, 5.231f)
                lineTo(7.08f, 5.406f)
                lineTo(7.111f, 5.452f)
                lineTo(7.291f, 5.329f)
                lineTo(7.009f, 5.801f)
                lineTo(6.974f, 5.777f)
                lineTo(7.025f, 5.675f)
                lineTo(6.9f, 5.579f)
                lineTo(6.727f, 5.87f)
                lineTo(6.899f, 6.172f)
                lineTo(6.972f, 6.106f)
                verticalLineTo(5.906f)
                lineTo(7.348f, 6.492f)
                lineTo(7.153f, 6.297f)
                lineTo(7.129f, 6.338f)
                lineTo(7.168f, 6.457f)
                lineTo(7.169f, 6.465f)
                verticalLineTo(6.55f)
                lineTo(7.5f, 6.976f)
                lineTo(7.469f, 7.006f)
                close()
                moveTo(7.128f, 3.705f)
                lineTo(7.469f, 4.144f)
                lineTo(7.5f, 4.113f)
                lineTo(7.169f, 3.688f)
                verticalLineTo(3.603f)
                lineTo(7.168f, 3.595f)
                lineTo(7.129f, 3.476f)
                lineTo(7.153f, 3.435f)
                lineTo(7.348f, 3.63f)
                lineTo(6.972f, 3.044f)
                verticalLineTo(3.244f)
                lineTo(6.899f, 3.309f)
                lineTo(6.727f, 3.007f)
                lineTo(6.9f, 2.717f)
                lineTo(7.025f, 2.813f)
                lineTo(6.974f, 2.915f)
                lineTo(7.009f, 2.939f)
                lineTo(7.291f, 2.467f)
                lineTo(7.111f, 2.59f)
                lineTo(7.08f, 2.544f)
                lineTo(7.252f, 2.369f)
                lineTo(7.176f, 2.285f)
                lineTo(7.427f, 1.918f)
                lineTo(7.395f, 1.889f)
                lineTo(7.121f, 2.289f)
                lineTo(7.192f, 2.367f)
                lineTo(7.024f, 2.539f)
                lineTo(7.101f, 2.651f)
                lineTo(7.153f, 2.616f)
                lineTo(7.055f, 2.78f)
                lineTo(6.889f, 2.653f)
                lineTo(6.678f, 3.007f)
                lineTo(6.889f, 3.377f)
                lineTo(7.012f, 3.266f)
                verticalLineTo(3.186f)
                lineTo(7.136f, 3.379f)
                lineTo(7.084f, 3.47f)
                lineTo(7.128f, 3.607f)
                verticalLineTo(3.705f)
                close()
                moveTo(7.469f, 1.005f)
                lineTo(7.128f, 0.566f)
                verticalLineTo(0.467f)
                lineTo(7.084f, 0.331f)
                lineTo(7.136f, 0.239f)
                lineTo(7.012f, 0.047f)
                verticalLineTo(0.127f)
                lineTo(6.889f, 0.238f)
                lineTo(6.678f, -0.132f)
                lineTo(6.889f, -0.487f)
                lineTo(7.055f, -0.359f)
                lineTo(7.153f, -0.524f)
                lineTo(7.101f, -0.488f)
                lineTo(7.024f, -0.601f)
                lineTo(7.192f, -0.772f)
                lineTo(7.121f, -0.85f)
                lineTo(7.395f, -1.25f)
                lineTo(7.427f, -1.222f)
                lineTo(7.176f, -0.854f)
                lineTo(7.252f, -0.771f)
                lineTo(7.08f, -0.595f)
                lineTo(7.111f, -0.549f)
                lineTo(7.291f, -0.672f)
                lineTo(7.009f, -0.2f)
                lineTo(6.974f, -0.224f)
                lineTo(7.025f, -0.326f)
                lineTo(6.9f, -0.422f)
                lineTo(6.727f, -0.132f)
                lineTo(6.899f, 0.17f)
                lineTo(6.972f, 0.105f)
                verticalLineTo(-0.096f)
                lineTo(7.348f, 0.491f)
                lineTo(7.153f, 0.295f)
                lineTo(7.129f, 0.337f)
                lineTo(7.168f, 0.455f)
                lineTo(7.169f, 0.463f)
                verticalLineTo(0.549f)
                lineTo(7.5f, 0.974f)
                lineTo(7.469f, 1.005f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF389F5D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.567f, 9.103f)
                horizontalLineTo(5.538f)
                verticalLineTo(9.331f)
                horizontalLineTo(5.759f)
                verticalLineTo(9.513f)
                horizontalLineTo(6.024f)
                verticalLineTo(10.105f)
                horizontalLineTo(5.759f)
                verticalLineTo(10.288f)
                horizontalLineTo(5.538f)
                verticalLineTo(10.47f)
                horizontalLineTo(4.593f)
                lineTo(4.331f, 10.702f)
                lineTo(4.068f, 10.47f)
                horizontalLineTo(3.192f)
                verticalLineTo(10.288f)
                horizontalLineTo(2.971f)
                verticalLineTo(10.105f)
                horizontalLineTo(2.75f)
                verticalLineTo(9.513f)
                horizontalLineTo(2.971f)
                verticalLineTo(9.331f)
                horizontalLineTo(3.192f)
                verticalLineTo(9.103f)
                horizontalLineTo(4.094f)
                lineTo(4.331f, 8.893f)
                lineTo(4.567f, 9.103f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(5.538f, 9.103f)
                horizontalLineTo(5.788f)
                verticalLineTo(8.853f)
                horizontalLineTo(5.538f)
                verticalLineTo(9.103f)
                close()
                moveTo(4.567f, 9.103f)
                lineTo(4.401f, 9.29f)
                lineTo(4.472f, 9.353f)
                horizontalLineTo(4.567f)
                verticalLineTo(9.103f)
                close()
                moveTo(5.538f, 9.331f)
                horizontalLineTo(5.288f)
                verticalLineTo(9.581f)
                horizontalLineTo(5.538f)
                verticalLineTo(9.331f)
                close()
                moveTo(5.759f, 9.331f)
                horizontalLineTo(6.009f)
                verticalLineTo(9.081f)
                horizontalLineTo(5.759f)
                verticalLineTo(9.331f)
                close()
                moveTo(5.759f, 9.513f)
                horizontalLineTo(5.509f)
                verticalLineTo(9.763f)
                horizontalLineTo(5.759f)
                verticalLineTo(9.513f)
                close()
                moveTo(6.024f, 9.513f)
                horizontalLineTo(6.274f)
                verticalLineTo(9.263f)
                horizontalLineTo(6.024f)
                verticalLineTo(9.513f)
                close()
                moveTo(6.024f, 10.105f)
                verticalLineTo(10.355f)
                horizontalLineTo(6.274f)
                verticalLineTo(10.105f)
                horizontalLineTo(6.024f)
                close()
                moveTo(5.759f, 10.105f)
                verticalLineTo(9.855f)
                horizontalLineTo(5.509f)
                verticalLineTo(10.105f)
                horizontalLineTo(5.759f)
                close()
                moveTo(5.759f, 10.288f)
                verticalLineTo(10.538f)
                horizontalLineTo(6.009f)
                verticalLineTo(10.288f)
                horizontalLineTo(5.759f)
                close()
                moveTo(5.538f, 10.288f)
                verticalLineTo(10.038f)
                horizontalLineTo(5.288f)
                verticalLineTo(10.288f)
                horizontalLineTo(5.538f)
                close()
                moveTo(5.538f, 10.47f)
                verticalLineTo(10.72f)
                horizontalLineTo(5.788f)
                verticalLineTo(10.47f)
                horizontalLineTo(5.538f)
                close()
                moveTo(4.593f, 10.47f)
                verticalLineTo(10.22f)
                horizontalLineTo(4.498f)
                lineTo(4.426f, 10.283f)
                lineTo(4.593f, 10.47f)
                close()
                moveTo(4.331f, 10.702f)
                lineTo(4.165f, 10.89f)
                lineTo(4.332f, 11.036f)
                lineTo(4.497f, 10.889f)
                lineTo(4.331f, 10.702f)
                close()
                moveTo(4.068f, 10.47f)
                lineTo(4.234f, 10.283f)
                lineTo(4.163f, 10.22f)
                horizontalLineTo(4.068f)
                verticalLineTo(10.47f)
                close()
                moveTo(3.192f, 10.47f)
                horizontalLineTo(2.942f)
                verticalLineTo(10.72f)
                horizontalLineTo(3.192f)
                verticalLineTo(10.47f)
                close()
                moveTo(3.192f, 10.288f)
                horizontalLineTo(3.442f)
                verticalLineTo(10.038f)
                horizontalLineTo(3.192f)
                verticalLineTo(10.288f)
                close()
                moveTo(2.971f, 10.288f)
                horizontalLineTo(2.721f)
                verticalLineTo(10.538f)
                horizontalLineTo(2.971f)
                verticalLineTo(10.288f)
                close()
                moveTo(2.971f, 10.105f)
                horizontalLineTo(3.221f)
                verticalLineTo(9.855f)
                horizontalLineTo(2.971f)
                verticalLineTo(10.105f)
                close()
                moveTo(2.75f, 10.105f)
                horizontalLineTo(2.5f)
                verticalLineTo(10.355f)
                horizontalLineTo(2.75f)
                verticalLineTo(10.105f)
                close()
                moveTo(2.75f, 9.513f)
                verticalLineTo(9.263f)
                horizontalLineTo(2.5f)
                verticalLineTo(9.513f)
                horizontalLineTo(2.75f)
                close()
                moveTo(2.971f, 9.513f)
                verticalLineTo(9.763f)
                horizontalLineTo(3.221f)
                verticalLineTo(9.513f)
                horizontalLineTo(2.971f)
                close()
                moveTo(2.971f, 9.331f)
                verticalLineTo(9.081f)
                horizontalLineTo(2.721f)
                verticalLineTo(9.331f)
                horizontalLineTo(2.971f)
                close()
                moveTo(3.192f, 9.331f)
                verticalLineTo(9.581f)
                horizontalLineTo(3.442f)
                verticalLineTo(9.331f)
                horizontalLineTo(3.192f)
                close()
                moveTo(3.192f, 9.103f)
                verticalLineTo(8.853f)
                horizontalLineTo(2.942f)
                verticalLineTo(9.103f)
                horizontalLineTo(3.192f)
                close()
                moveTo(4.094f, 9.103f)
                verticalLineTo(9.353f)
                horizontalLineTo(4.189f)
                lineTo(4.26f, 9.29f)
                lineTo(4.094f, 9.103f)
                close()
                moveTo(4.331f, 8.893f)
                lineTo(4.497f, 8.707f)
                lineTo(4.332f, 8.559f)
                lineTo(4.165f, 8.706f)
                lineTo(4.331f, 8.893f)
                close()
                moveTo(5.538f, 8.853f)
                horizontalLineTo(4.567f)
                verticalLineTo(9.353f)
                horizontalLineTo(5.538f)
                verticalLineTo(8.853f)
                close()
                moveTo(5.788f, 9.331f)
                verticalLineTo(9.103f)
                horizontalLineTo(5.288f)
                verticalLineTo(9.331f)
                horizontalLineTo(5.788f)
                close()
                moveTo(5.759f, 9.081f)
                horizontalLineTo(5.538f)
                verticalLineTo(9.581f)
                horizontalLineTo(5.759f)
                verticalLineTo(9.081f)
                close()
                moveTo(6.009f, 9.513f)
                verticalLineTo(9.331f)
                horizontalLineTo(5.509f)
                verticalLineTo(9.513f)
                horizontalLineTo(6.009f)
                close()
                moveTo(6.024f, 9.263f)
                horizontalLineTo(5.759f)
                verticalLineTo(9.763f)
                horizontalLineTo(6.024f)
                verticalLineTo(9.263f)
                close()
                moveTo(6.274f, 10.105f)
                verticalLineTo(9.513f)
                horizontalLineTo(5.774f)
                verticalLineTo(10.105f)
                horizontalLineTo(6.274f)
                close()
                moveTo(5.759f, 10.355f)
                horizontalLineTo(6.024f)
                verticalLineTo(9.855f)
                horizontalLineTo(5.759f)
                verticalLineTo(10.355f)
                close()
                moveTo(6.009f, 10.288f)
                verticalLineTo(10.105f)
                horizontalLineTo(5.509f)
                verticalLineTo(10.288f)
                horizontalLineTo(6.009f)
                close()
                moveTo(5.538f, 10.538f)
                horizontalLineTo(5.759f)
                verticalLineTo(10.038f)
                horizontalLineTo(5.538f)
                verticalLineTo(10.538f)
                close()
                moveTo(5.788f, 10.47f)
                verticalLineTo(10.288f)
                horizontalLineTo(5.288f)
                verticalLineTo(10.47f)
                horizontalLineTo(5.788f)
                close()
                moveTo(4.593f, 10.72f)
                horizontalLineTo(5.538f)
                verticalLineTo(10.22f)
                horizontalLineTo(4.593f)
                verticalLineTo(10.72f)
                close()
                moveTo(4.497f, 10.889f)
                lineTo(4.759f, 10.657f)
                lineTo(4.426f, 10.283f)
                lineTo(4.165f, 10.516f)
                lineTo(4.497f, 10.889f)
                close()
                moveTo(3.903f, 10.657f)
                lineTo(4.165f, 10.89f)
                lineTo(4.497f, 10.515f)
                lineTo(4.234f, 10.283f)
                lineTo(3.903f, 10.657f)
                close()
                moveTo(3.192f, 10.72f)
                horizontalLineTo(4.068f)
                verticalLineTo(10.22f)
                horizontalLineTo(3.192f)
                verticalLineTo(10.72f)
                close()
                moveTo(2.942f, 10.288f)
                verticalLineTo(10.47f)
                horizontalLineTo(3.442f)
                verticalLineTo(10.288f)
                horizontalLineTo(2.942f)
                close()
                moveTo(2.971f, 10.538f)
                horizontalLineTo(3.192f)
                verticalLineTo(10.038f)
                horizontalLineTo(2.971f)
                verticalLineTo(10.538f)
                close()
                moveTo(2.721f, 10.105f)
                verticalLineTo(10.288f)
                horizontalLineTo(3.221f)
                verticalLineTo(10.105f)
                horizontalLineTo(2.721f)
                close()
                moveTo(2.75f, 10.355f)
                horizontalLineTo(2.971f)
                verticalLineTo(9.855f)
                horizontalLineTo(2.75f)
                verticalLineTo(10.355f)
                close()
                moveTo(2.5f, 9.513f)
                verticalLineTo(10.105f)
                horizontalLineTo(3f)
                verticalLineTo(9.513f)
                horizontalLineTo(2.5f)
                close()
                moveTo(2.971f, 9.263f)
                horizontalLineTo(2.75f)
                verticalLineTo(9.763f)
                horizontalLineTo(2.971f)
                verticalLineTo(9.263f)
                close()
                moveTo(2.721f, 9.331f)
                verticalLineTo(9.513f)
                horizontalLineTo(3.221f)
                verticalLineTo(9.331f)
                horizontalLineTo(2.721f)
                close()
                moveTo(3.192f, 9.081f)
                horizontalLineTo(2.971f)
                verticalLineTo(9.581f)
                horizontalLineTo(3.192f)
                verticalLineTo(9.081f)
                close()
                moveTo(2.942f, 9.103f)
                verticalLineTo(9.331f)
                horizontalLineTo(3.442f)
                verticalLineTo(9.103f)
                horizontalLineTo(2.942f)
                close()
                moveTo(4.094f, 8.853f)
                horizontalLineTo(3.192f)
                verticalLineTo(9.353f)
                horizontalLineTo(4.094f)
                verticalLineTo(8.853f)
                close()
                moveTo(4.26f, 9.29f)
                lineTo(4.497f, 9.081f)
                lineTo(4.165f, 8.706f)
                lineTo(3.929f, 8.916f)
                lineTo(4.26f, 9.29f)
                close()
                moveTo(4.165f, 9.08f)
                lineTo(4.401f, 9.29f)
                lineTo(4.733f, 8.916f)
                lineTo(4.497f, 8.707f)
                lineTo(4.165f, 9.08f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.322f, 9.63f)
                verticalLineTo(9.227f)
                horizontalLineTo(3.791f)
                lineTo(3.322f, 9.63f)
                close()
                moveTo(5.296f, 9.63f)
                verticalLineTo(9.227f)
                horizontalLineTo(4.826f)
                lineTo(5.296f, 9.63f)
                close()
                moveTo(3.322f, 10.359f)
                verticalLineTo(9.956f)
                lineTo(3.791f, 10.359f)
                horizontalLineTo(3.322f)
                close()
                moveTo(5.296f, 9.956f)
                verticalLineTo(10.359f)
                horizontalLineTo(4.826f)
                lineTo(5.296f, 9.956f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.153f, 9.262f)
                lineTo(4.315f, 9.05f)
                lineTo(4.475f, 9.262f)
                horizontalLineTo(4.153f)
                close()
                moveTo(4.153f, 9.46f)
                lineTo(4.315f, 9.672f)
                lineTo(4.475f, 9.46f)
                horizontalLineTo(4.153f)
                close()
                moveTo(4.315f, 9.961f)
                lineTo(4.153f, 10.173f)
                horizontalLineTo(4.475f)
                lineTo(4.315f, 9.961f)
                close()
                moveTo(4.153f, 10.371f)
                lineTo(4.315f, 10.583f)
                lineTo(4.475f, 10.371f)
                horizontalLineTo(4.153f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.157f, 9.236f)
                verticalLineTo(9.328f)
                horizontalLineTo(4.064f)
                verticalLineTo(9.453f)
                horizontalLineTo(4.157f)
                verticalLineTo(9.544f)
                horizontalLineTo(4.481f)
                verticalLineTo(9.453f)
                horizontalLineTo(4.574f)
                verticalLineTo(9.328f)
                horizontalLineTo(4.481f)
                verticalLineTo(9.236f)
                horizontalLineTo(4.157f)
                close()
                moveTo(4.481f, 10.239f)
                verticalLineTo(10.148f)
                horizontalLineTo(4.157f)
                verticalLineTo(10.239f)
                horizontalLineTo(4.064f)
                verticalLineTo(10.364f)
                horizontalLineTo(4.157f)
                verticalLineTo(10.455f)
                horizontalLineTo(4.481f)
                verticalLineTo(10.364f)
                horizontalLineTo(4.574f)
                verticalLineTo(10.239f)
                horizontalLineTo(4.481f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.534f, 9.718f)
                lineTo(3.688f, 9.505f)
                lineTo(3.84f, 9.718f)
                horizontalLineTo(3.534f)
                close()
                moveTo(3.534f, 9.917f)
                lineTo(3.688f, 10.13f)
                lineTo(3.84f, 9.917f)
                horizontalLineTo(3.534f)
                close()
                moveTo(4.971f, 9.505f)
                lineTo(4.817f, 9.718f)
                horizontalLineTo(5.123f)
                lineTo(4.971f, 9.505f)
                close()
                moveTo(4.817f, 9.917f)
                lineTo(4.971f, 10.13f)
                lineTo(5.123f, 9.917f)
                horizontalLineTo(4.817f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.533f, 9.692f)
                verticalLineTo(9.785f)
                horizontalLineTo(3.444f)
                verticalLineTo(9.913f)
                horizontalLineTo(3.533f)
                verticalLineTo(10.006f)
                horizontalLineTo(3.841f)
                verticalLineTo(9.913f)
                horizontalLineTo(3.93f)
                verticalLineTo(9.785f)
                horizontalLineTo(3.841f)
                verticalLineTo(9.692f)
                horizontalLineTo(3.533f)
                close()
                moveTo(5.125f, 9.785f)
                verticalLineTo(9.692f)
                horizontalLineTo(4.816f)
                verticalLineTo(9.785f)
                horizontalLineTo(4.727f)
                verticalLineTo(9.913f)
                horizontalLineTo(4.816f)
                verticalLineTo(10.006f)
                horizontalLineTo(5.125f)
                verticalLineTo(9.913f)
                horizontalLineTo(5.213f)
                verticalLineTo(9.785f)
                horizontalLineTo(5.125f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(3.886f, 10.782f)
                lineTo(2.778f, 11.406f)
                verticalLineTo(12.441f)
                lineTo(3.886f, 13.09f)
                horizontalLineTo(5.085f)
                lineTo(6.218f, 12.441f)
                verticalLineTo(11.406f)
                lineTo(5.085f, 10.782f)
                horizontalLineTo(3.886f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(2.794f, 11.935f)
                horizontalLineTo(4.52f)
                verticalLineTo(13.074f)
                horizontalLineTo(2.794f)
                verticalLineTo(11.935f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(2.617f, 10.796f)
                horizontalLineToRelative(1.903f)
                verticalLineToRelative(1.139f)
                horizontalLineToRelative(-1.903f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(3.06f, 11.46f)
                lineTo(3.633f, 11.115f)
                verticalLineTo(11.46f)
                horizontalLineTo(3.06f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(6.423f, 10.796f)
                lineToRelative(-1.903f, 0f)
                lineToRelative(-0f, 1.139f)
                lineToRelative(1.903f, 0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(5.847f, 11.46f)
                lineTo(5.275f, 11.115f)
                verticalLineTo(11.46f)
                horizontalLineTo(5.847f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(6.246f, 13.074f)
                lineToRelative(-1.726f, -0f)
                lineToRelative(-0f, -1.139f)
                lineToRelative(1.726f, -0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(5.803f, 12.41f)
                lineTo(5.23f, 12.755f)
                verticalLineTo(12.41f)
                horizontalLineTo(5.803f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFCFCFC))) {
                moveTo(3.06f, 12.338f)
                lineTo(3.633f, 12.683f)
                verticalLineTo(12.338f)
                horizontalLineTo(3.06f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.9f, 11.479f)
            horizontalLineTo(4.188f)
            lineTo(4.476f, 11.388f)
            lineTo(4.763f, 11.479f)
            horizontalLineTo(5.051f)
            verticalLineTo(12.345f)
            horizontalLineTo(4.763f)
            lineTo(4.476f, 12.482f)
            lineTo(4.188f, 12.345f)
            horizontalLineTo(3.9f)
            verticalLineTo(11.479f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC9343F)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.874f, 10.961f)
            horizontalLineTo(5.03f)
            verticalLineTo(11.137f)
            horizontalLineTo(5.094f)
            verticalLineTo(11.262f)
            horizontalLineTo(5.03f)
            verticalLineTo(11.33f)
            horizontalLineTo(4.874f)
            verticalLineTo(10.961f)
            close()
            moveTo(3.304f, 11.508f)
            horizontalLineTo(3.148f)
            verticalLineTo(11.877f)
            horizontalLineTo(3.304f)
            verticalLineTo(11.809f)
            horizontalLineTo(3.368f)
            verticalLineTo(11.684f)
            horizontalLineTo(3.304f)
            verticalLineTo(11.508f)
            close()
            moveTo(3.526f, 11.508f)
            horizontalLineTo(3.369f)
            verticalLineTo(11.877f)
            horizontalLineTo(3.526f)
            verticalLineTo(11.508f)
            close()
            moveTo(3.304f, 11.964f)
            horizontalLineTo(3.148f)
            verticalLineTo(12.332f)
            horizontalLineTo(3.304f)
            verticalLineTo(12.265f)
            horizontalLineTo(3.368f)
            verticalLineTo(12.14f)
            horizontalLineTo(3.304f)
            verticalLineTo(11.964f)
            close()
            moveTo(3.369f, 11.964f)
            horizontalLineTo(3.526f)
            verticalLineTo(12.332f)
            horizontalLineTo(3.369f)
            verticalLineTo(11.964f)
            close()
            moveTo(5.582f, 11.508f)
            horizontalLineTo(5.738f)
            verticalLineTo(11.684f)
            horizontalLineTo(5.802f)
            verticalLineTo(11.809f)
            horizontalLineTo(5.738f)
            verticalLineTo(11.877f)
            horizontalLineTo(5.582f)
            verticalLineTo(11.508f)
            close()
            moveTo(5.959f, 11.508f)
            horizontalLineTo(5.803f)
            verticalLineTo(11.877f)
            horizontalLineTo(5.959f)
            verticalLineTo(11.508f)
            close()
            moveTo(5.738f, 11.964f)
            horizontalLineTo(5.582f)
            verticalLineTo(12.332f)
            horizontalLineTo(5.738f)
            verticalLineTo(12.265f)
            horizontalLineTo(5.802f)
            verticalLineTo(12.14f)
            horizontalLineTo(5.738f)
            verticalLineTo(11.964f)
            close()
            moveTo(5.803f, 11.964f)
            horizontalLineTo(5.959f)
            verticalLineTo(12.332f)
            horizontalLineTo(5.803f)
            verticalLineTo(11.964f)
            close()
            moveTo(5.251f, 10.961f)
            horizontalLineTo(5.095f)
            verticalLineTo(11.33f)
            horizontalLineTo(5.251f)
            verticalLineTo(10.961f)
            close()
            moveTo(3.968f, 10.961f)
            horizontalLineTo(3.812f)
            verticalLineTo(11.33f)
            horizontalLineTo(3.968f)
            verticalLineTo(11.262f)
            horizontalLineTo(4.032f)
            verticalLineTo(11.137f)
            horizontalLineTo(3.968f)
            verticalLineTo(10.961f)
            close()
            moveTo(4.033f, 10.961f)
            horizontalLineTo(4.189f)
            verticalLineTo(11.33f)
            horizontalLineTo(4.033f)
            verticalLineTo(10.961f)
            close()
            moveTo(4.874f, 12.51f)
            horizontalLineTo(5.03f)
            verticalLineTo(12.687f)
            horizontalLineTo(5.094f)
            verticalLineTo(12.812f)
            horizontalLineTo(5.03f)
            verticalLineTo(12.879f)
            horizontalLineTo(4.874f)
            verticalLineTo(12.51f)
            close()
            moveTo(5.251f, 12.51f)
            horizontalLineTo(5.095f)
            verticalLineTo(12.879f)
            horizontalLineTo(5.251f)
            verticalLineTo(12.51f)
            close()
            moveTo(3.968f, 12.51f)
            horizontalLineTo(3.812f)
            verticalLineTo(12.879f)
            horizontalLineTo(3.968f)
            verticalLineTo(12.812f)
            horizontalLineTo(4.032f)
            verticalLineTo(12.687f)
            horizontalLineTo(3.968f)
            verticalLineTo(12.51f)
            close()
            moveTo(4.033f, 12.51f)
            horizontalLineTo(4.189f)
            verticalLineTo(12.879f)
            horizontalLineTo(4.033f)
            verticalLineTo(12.51f)
            close()
        }
        path(
            fill = SolidColor(Color.White),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.391f, 11.666f)
            horizontalLineTo(4.435f)
            verticalLineTo(11.542f)
            horizontalLineTo(4.214f)
            verticalLineTo(11.684f)
            horizontalLineTo(4.032f)
            verticalLineTo(11.887f)
            horizontalLineTo(4.201f)
            verticalLineTo(11.842f)
            horizontalLineTo(4.076f)
            verticalLineTo(11.73f)
            horizontalLineTo(4.226f)
            lineTo(4.452f, 11.925f)
            lineTo(4.226f, 12.121f)
            horizontalLineTo(4.076f)
            verticalLineTo(12.009f)
            horizontalLineTo(4.201f)
            verticalLineTo(11.964f)
            horizontalLineTo(4.032f)
            verticalLineTo(12.167f)
            horizontalLineTo(4.214f)
            verticalLineTo(12.308f)
            horizontalLineTo(4.435f)
            verticalLineTo(12.184f)
            horizontalLineTo(4.391f)
            verticalLineTo(12.263f)
            horizontalLineTo(4.258f)
            verticalLineTo(12.153f)
            lineTo(4.488f, 11.954f)
            lineTo(4.718f, 12.153f)
            verticalLineTo(12.263f)
            horizontalLineTo(4.586f)
            verticalLineTo(12.184f)
            horizontalLineTo(4.541f)
            verticalLineTo(12.308f)
            horizontalLineTo(4.762f)
            verticalLineTo(12.167f)
            horizontalLineTo(4.945f)
            verticalLineTo(11.964f)
            horizontalLineTo(4.775f)
            verticalLineTo(12.009f)
            horizontalLineTo(4.9f)
            verticalLineTo(12.121f)
            horizontalLineTo(4.75f)
            lineTo(4.524f, 11.925f)
            lineTo(4.75f, 11.73f)
            horizontalLineTo(4.9f)
            verticalLineTo(11.842f)
            horizontalLineTo(4.775f)
            verticalLineTo(11.887f)
            horizontalLineTo(4.945f)
            verticalLineTo(11.684f)
            horizontalLineTo(4.762f)
            verticalLineTo(11.542f)
            horizontalLineTo(4.541f)
            verticalLineTo(11.666f)
            horizontalLineTo(4.586f)
            verticalLineTo(11.588f)
            horizontalLineTo(4.718f)
            verticalLineTo(11.698f)
            lineTo(4.488f, 11.897f)
            lineTo(4.258f, 11.698f)
            verticalLineTo(11.588f)
            horizontalLineTo(4.391f)
            verticalLineTo(11.666f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.74f, 3f)
            horizontalLineTo(3.961f)
            verticalLineTo(5.5f)
            horizontalLineTo(4.74f)
            verticalLineTo(3f)
            close()
            moveTo(2.987f, 3.529f)
            horizontalLineTo(3.474f)
            verticalLineTo(4.875f)
            horizontalLineTo(2.987f)
            verticalLineTo(3.529f)
            close()
            moveTo(5.276f, 3.529f)
            horizontalLineTo(5.763f)
            verticalLineTo(4.875f)
            horizontalLineTo(5.276f)
            verticalLineTo(3.529f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.961f, 3.192f)
            horizontalLineTo(3.474f)
            verticalLineTo(5.115f)
            horizontalLineTo(3.961f)
            verticalLineTo(3.192f)
            close()
            moveTo(2.987f, 3.721f)
            horizontalLineTo(2.5f)
            verticalLineTo(4.635f)
            horizontalLineTo(2.987f)
            verticalLineTo(3.721f)
            close()
            moveTo(5.763f, 3.721f)
            horizontalLineTo(6.25f)
            verticalLineTo(4.635f)
            horizontalLineTo(5.763f)
            verticalLineTo(3.721f)
            close()
            moveTo(5.227f, 3.192f)
            horizontalLineTo(4.74f)
            verticalLineTo(5.115f)
            horizontalLineTo(5.227f)
            verticalLineTo(3.192f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.864f, 3.433f)
            curveTo(3.864f, 3.512f, 3.798f, 3.577f, 3.718f, 3.577f)
            curveTo(3.637f, 3.577f, 3.571f, 3.512f, 3.571f, 3.433f)
            curveTo(3.571f, 3.353f, 3.637f, 3.288f, 3.718f, 3.288f)
            curveTo(3.798f, 3.288f, 3.864f, 3.353f, 3.864f, 3.433f)
            close()
            moveTo(2.89f, 3.913f)
            curveTo(2.89f, 3.993f, 2.824f, 4.058f, 2.743f, 4.058f)
            curveTo(2.663f, 4.058f, 2.597f, 3.993f, 2.597f, 3.913f)
            curveTo(2.597f, 3.834f, 2.663f, 3.769f, 2.743f, 3.769f)
            curveTo(2.824f, 3.769f, 2.89f, 3.834f, 2.89f, 3.913f)
            close()
            moveTo(2.89f, 4.442f)
            curveTo(2.89f, 4.522f, 2.824f, 4.587f, 2.743f, 4.587f)
            curveTo(2.663f, 4.587f, 2.597f, 4.522f, 2.597f, 4.442f)
            curveTo(2.597f, 4.363f, 2.663f, 4.298f, 2.743f, 4.298f)
            curveTo(2.824f, 4.298f, 2.89f, 4.363f, 2.89f, 4.442f)
            close()
            moveTo(3.718f, 5.019f)
            curveTo(3.798f, 5.019f, 3.864f, 4.955f, 3.864f, 4.875f)
            curveTo(3.864f, 4.795f, 3.798f, 4.731f, 3.718f, 4.731f)
            curveTo(3.637f, 4.731f, 3.571f, 4.795f, 3.571f, 4.875f)
            curveTo(3.571f, 4.955f, 3.637f, 5.019f, 3.718f, 5.019f)
            close()
            moveTo(6.006f, 4.058f)
            curveTo(6.087f, 4.058f, 6.153f, 3.993f, 6.153f, 3.913f)
            curveTo(6.153f, 3.834f, 6.087f, 3.769f, 6.006f, 3.769f)
            curveTo(5.926f, 3.769f, 5.86f, 3.834f, 5.86f, 3.913f)
            curveTo(5.86f, 3.993f, 5.926f, 4.058f, 6.006f, 4.058f)
            close()
            moveTo(6.153f, 4.442f)
            curveTo(6.153f, 4.522f, 6.087f, 4.587f, 6.006f, 4.587f)
            curveTo(5.926f, 4.587f, 5.86f, 4.522f, 5.86f, 4.442f)
            curveTo(5.86f, 4.363f, 5.926f, 4.298f, 6.006f, 4.298f)
            curveTo(6.087f, 4.298f, 6.153f, 4.363f, 6.153f, 4.442f)
            close()
            moveTo(4.984f, 5.019f)
            curveTo(5.064f, 5.019f, 5.13f, 4.955f, 5.13f, 4.875f)
            curveTo(5.13f, 4.795f, 5.064f, 4.731f, 4.984f, 4.731f)
            curveTo(4.903f, 4.731f, 4.838f, 4.795f, 4.838f, 4.875f)
            curveTo(4.838f, 4.955f, 4.903f, 5.019f, 4.984f, 5.019f)
            close()
            moveTo(5.13f, 3.433f)
            curveTo(5.13f, 3.512f, 5.064f, 3.577f, 4.984f, 3.577f)
            curveTo(4.903f, 3.577f, 4.838f, 3.512f, 4.838f, 3.433f)
            curveTo(4.838f, 3.353f, 4.903f, 3.288f, 4.984f, 3.288f)
            curveTo(5.064f, 3.288f, 5.13f, 3.353f, 5.13f, 3.433f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.497f, 3.24f)
            curveTo(4.497f, 3.32f, 4.431f, 3.385f, 4.351f, 3.385f)
            curveTo(4.27f, 3.385f, 4.205f, 3.32f, 4.205f, 3.24f)
            curveTo(4.205f, 3.161f, 4.27f, 3.096f, 4.351f, 3.096f)
            curveTo(4.431f, 3.096f, 4.497f, 3.161f, 4.497f, 3.24f)
            close()
            moveTo(3.377f, 3.769f)
            curveTo(3.377f, 3.849f, 3.311f, 3.913f, 3.231f, 3.913f)
            curveTo(3.15f, 3.913f, 3.084f, 3.849f, 3.084f, 3.769f)
            curveTo(3.084f, 3.69f, 3.15f, 3.625f, 3.231f, 3.625f)
            curveTo(3.311f, 3.625f, 3.377f, 3.69f, 3.377f, 3.769f)
            close()
            moveTo(4.351f, 5.452f)
            curveTo(4.431f, 5.452f, 4.497f, 5.387f, 4.497f, 5.308f)
            curveTo(4.497f, 5.228f, 4.431f, 5.163f, 4.351f, 5.163f)
            curveTo(4.27f, 5.163f, 4.205f, 5.228f, 4.205f, 5.308f)
            curveTo(4.205f, 5.387f, 4.27f, 5.452f, 4.351f, 5.452f)
            close()
            moveTo(5.666f, 3.769f)
            curveTo(5.666f, 3.849f, 5.6f, 3.913f, 5.519f, 3.913f)
            curveTo(5.439f, 3.913f, 5.373f, 3.849f, 5.373f, 3.769f)
            curveTo(5.373f, 3.69f, 5.439f, 3.625f, 5.519f, 3.625f)
            curveTo(5.6f, 3.625f, 5.666f, 3.69f, 5.666f, 3.769f)
            close()
            moveTo(3.231f, 4.779f)
            curveTo(3.311f, 4.779f, 3.377f, 4.714f, 3.377f, 4.635f)
            curveTo(3.377f, 4.555f, 3.311f, 4.49f, 3.231f, 4.49f)
            curveTo(3.15f, 4.49f, 3.084f, 4.555f, 3.084f, 4.635f)
            curveTo(3.084f, 4.714f, 3.15f, 4.779f, 3.231f, 4.779f)
            close()
            moveTo(5.666f, 4.635f)
            curveTo(5.666f, 4.714f, 5.6f, 4.779f, 5.519f, 4.779f)
            curveTo(5.439f, 4.779f, 5.373f, 4.714f, 5.373f, 4.635f)
            curveTo(5.373f, 4.555f, 5.439f, 4.49f, 5.519f, 4.49f)
            curveTo(5.6f, 4.49f, 5.666f, 4.555f, 5.666f, 4.635f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.504f, 3.995f)
            lineTo(3.978f, 3.566f)
            horizontalLineTo(4.748f)
            lineTo(5.288f, 4.058f)
            horizontalLineTo(6.006f)
            verticalLineTo(4.25f)
            horizontalLineTo(5.308f)
            verticalLineTo(4.26f)
            lineTo(4.748f, 4.829f)
            horizontalLineTo(3.978f)
            lineTo(3.504f, 4.316f)
            verticalLineTo(4.25f)
            horizontalLineTo(2.695f)
            verticalLineTo(4.058f)
            horizontalLineTo(3.504f)
            verticalLineTo(3.995f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.382f, 3.923f)
            lineTo(4.612f, 4.156f)
            lineTo(4.37f, 4.385f)
            lineTo(4.129f, 4.156f)
            lineTo(4.359f, 3.923f)
            lineTo(4.37f, 3.912f)
            lineTo(4.382f, 3.923f)
            close()
            moveTo(4.424f, 4.486f)
            lineTo(4.451f, 4.461f)
            lineTo(4.423f, 4.435f)
            lineTo(4.663f, 4.208f)
            lineTo(4.913f, 4.461f)
            lineTo(4.801f, 4.58f)
            horizontalLineTo(4.734f)
            lineTo(4.61f, 4.658f)
            lineTo(4.424f, 4.486f)
            close()
            moveTo(4.37f, 4.536f)
            lineTo(4.14f, 4.749f)
            lineTo(3.986f, 4.652f)
            horizontalLineTo(3.908f)
            lineTo(3.727f, 4.46f)
            lineTo(4.025f, 4.158f)
            lineTo(3.725f, 3.873f)
            lineTo(3.922f, 3.682f)
            lineTo(3.993f, 3.738f)
            lineTo(4.097f, 3.634f)
            lineTo(4.065f, 3.602f)
            lineTo(4.118f, 3.552f)
            lineTo(4.37f, 3.808f)
            lineTo(4.623f, 3.552f)
            lineTo(4.675f, 3.602f)
            lineTo(4.644f, 3.634f)
            lineTo(4.748f, 3.738f)
            lineTo(4.819f, 3.682f)
            lineTo(5.016f, 3.873f)
            lineTo(4.716f, 4.158f)
            lineTo(5.014f, 4.46f)
            lineTo(4.832f, 4.652f)
            horizontalLineTo(4.755f)
            lineTo(4.601f, 4.749f)
            lineTo(4.37f, 4.536f)
            close()
            moveTo(4.499f, 3.938f)
            lineTo(4.502f, 3.935f)
            lineTo(4.433f, 3.871f)
            lineTo(4.424f, 3.862f)
            lineTo(4.604f, 3.696f)
            lineTo(4.742f, 3.835f)
            lineTo(4.814f, 3.778f)
            lineTo(4.911f, 3.873f)
            lineTo(4.665f, 4.106f)
            lineTo(4.499f, 3.938f)
            close()
            moveTo(4.345f, 4.461f)
            lineTo(4.131f, 4.658f)
            lineTo(4.007f, 4.58f)
            horizontalLineTo(3.94f)
            lineTo(3.828f, 4.461f)
            lineTo(4.078f, 4.208f)
            lineTo(4.345f, 4.461f)
            close()
            moveTo(3.829f, 3.873f)
            lineTo(4.076f, 4.106f)
            lineTo(4.317f, 3.862f)
            lineTo(4.137f, 3.696f)
            lineTo(3.999f, 3.835f)
            lineTo(3.927f, 3.778f)
            lineTo(3.829f, 3.873f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.78f, 13.401f)
            lineTo(2.78f, 13.401f)
            curveTo(2.65f, 13.235f, 2.561f, 13.123f, 2.538f, 13.125f)
            curveTo(2.465f, 13.13f, 2.397f, 13.902f, 3.345f, 14.49f)
            curveTo(3.345f, 14.49f, 3.485f, 14.568f, 3.566f, 14.49f)
            curveTo(3.648f, 14.412f, 3.566f, 14.297f, 3.566f, 14.297f)
            curveTo(3.26f, 14.01f, 2.973f, 13.646f, 2.78f, 13.401f)
            close()
            moveTo(5.97f, 13.401f)
            lineTo(5.97f, 13.401f)
            lineTo(5.97f, 13.401f)
            curveTo(6.1f, 13.235f, 6.189f, 13.123f, 6.212f, 13.125f)
            curveTo(6.285f, 13.13f, 6.353f, 13.902f, 5.405f, 14.49f)
            curveTo(5.405f, 14.49f, 5.265f, 14.568f, 5.184f, 14.49f)
            curveTo(5.102f, 14.412f, 5.184f, 14.297f, 5.184f, 14.297f)
            curveTo(5.49f, 14.01f, 5.777f, 13.646f, 5.97f, 13.401f)
            lineTo(5.97f, 13.401f)
            close()
            moveTo(5.9f, 14.44f)
            curveTo(5.589f, 14.532f, 5.228f, 14.551f, 5.09f, 14.492f)
            curveTo(5.046f, 14.473f, 5f, 14.458f, 4.951f, 14.447f)
            curveTo(4.813f, 14.415f, 4.68f, 14.415f, 4.521f, 14.433f)
            lineTo(4.462f, 14.439f)
            lineTo(4.458f, 14.44f)
            curveTo(4.443f, 14.441f, 4.435f, 14.442f, 4.433f, 14.442f)
            curveTo(4.424f, 14.442f, 4.414f, 14.444f, 4.402f, 14.446f)
            curveTo(4.391f, 14.444f, 4.381f, 14.442f, 4.372f, 14.442f)
            curveTo(4.37f, 14.442f, 4.361f, 14.441f, 4.346f, 14.44f)
            curveTo(4.346f, 14.44f, 4.345f, 14.44f, 4.343f, 14.439f)
            curveTo(4.331f, 14.438f, 4.297f, 14.434f, 4.284f, 14.433f)
            curveTo(4.125f, 14.415f, 3.991f, 14.415f, 3.854f, 14.447f)
            curveTo(3.805f, 14.458f, 3.758f, 14.473f, 3.714f, 14.492f)
            curveTo(3.576f, 14.551f, 3.216f, 14.532f, 2.904f, 14.44f)
            curveTo(2.904f, 14.44f, 3.471f, 14.667f, 3.808f, 14.567f)
            curveTo(3.84f, 14.552f, 3.875f, 14.542f, 3.911f, 14.533f)
            curveTo(4.007f, 14.512f, 4.105f, 14.51f, 4.223f, 14.521f)
            curveTo(4.173f, 14.544f, 4.116f, 14.57f, 4.048f, 14.597f)
            verticalLineTo(14.625f)
            curveTo(4.181f, 14.571f, 4.336f, 14.546f, 4.402f, 14.538f)
            curveTo(4.468f, 14.546f, 4.624f, 14.571f, 4.756f, 14.625f)
            verticalLineTo(14.597f)
            curveTo(4.689f, 14.57f, 4.631f, 14.544f, 4.582f, 14.521f)
            curveTo(4.7f, 14.51f, 4.798f, 14.512f, 4.894f, 14.533f)
            curveTo(4.93f, 14.542f, 4.964f, 14.552f, 4.997f, 14.567f)
            curveTo(5.334f, 14.667f, 5.9f, 14.44f, 5.9f, 14.44f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.602f, 6.236f)
            lineTo(2.82f, 6.925f)
            verticalLineTo(7.582f)
            lineTo(3.504f, 8.27f)
            horizontalLineTo(4.901f)
            lineTo(5.671f, 7.536f)
            verticalLineTo(6.977f)
            lineTo(4.901f, 6.236f)
            horizontalLineTo(3.602f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.872f, 6.309f)
            horizontalLineTo(3.695f)
            verticalLineTo(6.446f)
            horizontalLineTo(3.872f)
            verticalLineTo(6.309f)
            close()
            moveTo(3.872f, 8.096f)
            horizontalLineTo(3.695f)
            verticalLineTo(8.233f)
            horizontalLineTo(3.872f)
            verticalLineTo(8.096f)
            close()
            moveTo(4.137f, 8.096f)
            horizontalLineTo(4.314f)
            verticalLineTo(8.233f)
            horizontalLineTo(4.137f)
            verticalLineTo(8.096f)
            close()
            moveTo(4.314f, 6.309f)
            horizontalLineTo(4.137f)
            verticalLineTo(6.446f)
            horizontalLineTo(4.314f)
            verticalLineTo(6.309f)
            close()
            moveTo(4.58f, 8.096f)
            horizontalLineTo(4.757f)
            verticalLineTo(8.233f)
            horizontalLineTo(4.58f)
            verticalLineTo(8.096f)
            close()
            moveTo(4.757f, 6.309f)
            horizontalLineTo(4.58f)
            verticalLineTo(6.446f)
            horizontalLineTo(4.757f)
            verticalLineTo(6.309f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.096f, 6.273f)
            horizontalLineTo(3.916f)
            verticalLineTo(6.41f)
            horizontalLineTo(4.096f)
            verticalLineTo(6.273f)
            close()
            moveTo(4.096f, 8.096f)
            horizontalLineTo(3.916f)
            verticalLineTo(8.233f)
            horizontalLineTo(4.096f)
            verticalLineTo(8.096f)
            close()
            moveTo(4.366f, 6.273f)
            horizontalLineTo(4.547f)
            verticalLineTo(6.41f)
            horizontalLineTo(4.366f)
            verticalLineTo(6.273f)
            close()
            moveTo(4.547f, 8.096f)
            horizontalLineTo(4.366f)
            verticalLineTo(8.233f)
            horizontalLineTo(4.547f)
            verticalLineTo(8.096f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF750100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.071f, 6.151f)
            horizontalLineTo(5.434f)
            verticalLineTo(6.516f)
            horizontalLineTo(5.772f)
            verticalLineTo(8.026f)
            horizontalLineTo(5.434f)
            verticalLineTo(8.337f)
            horizontalLineTo(3.071f)
            verticalLineTo(8.026f)
            horizontalLineTo(2.704f)
            verticalLineTo(6.516f)
            horizontalLineTo(3.071f)
            verticalLineTo(6.151f)
            close()
            moveTo(3.204f, 6.653f)
            horizontalLineTo(2.836f)
            verticalLineTo(7.889f)
            horizontalLineTo(3.204f)
            verticalLineTo(8.201f)
            horizontalLineTo(5.301f)
            verticalLineTo(7.889f)
            horizontalLineTo(5.639f)
            verticalLineTo(6.653f)
            horizontalLineTo(5.301f)
            verticalLineTo(6.288f)
            horizontalLineTo(3.204f)
            verticalLineTo(6.653f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.004f, 6f)
            horizontalLineTo(3.783f)
            verticalLineTo(6.228f)
            horizontalLineTo(4.004f)
            verticalLineTo(6f)
            close()
            moveTo(4.358f, 6f)
            horizontalLineTo(4.137f)
            verticalLineTo(6.228f)
            horizontalLineTo(4.358f)
            verticalLineTo(6f)
            close()
            moveTo(4.491f, 6f)
            horizontalLineTo(4.712f)
            verticalLineTo(6.228f)
            horizontalLineTo(4.491f)
            verticalLineTo(6f)
            close()
            moveTo(4.004f, 8.279f)
            horizontalLineTo(3.783f)
            verticalLineTo(8.507f)
            horizontalLineTo(4.004f)
            verticalLineTo(8.279f)
            close()
            moveTo(4.137f, 8.279f)
            horizontalLineTo(4.358f)
            verticalLineTo(8.507f)
            horizontalLineTo(4.137f)
            verticalLineTo(8.279f)
            close()
            moveTo(4.712f, 8.279f)
            horizontalLineTo(4.491f)
            verticalLineTo(8.507f)
            horizontalLineTo(4.712f)
            verticalLineTo(8.279f)
            close()
            moveTo(2.497f, 7.774f)
            verticalLineTo(7.553f)
            horizontalLineTo(2.725f)
            verticalLineTo(7.774f)
            horizontalLineTo(2.497f)
            close()
            moveTo(2.497f, 7.188f)
            verticalLineTo(7.409f)
            horizontalLineTo(2.725f)
            verticalLineTo(7.188f)
            horizontalLineTo(2.497f)
            close()
            moveTo(2.497f, 7.045f)
            verticalLineTo(6.824f)
            horizontalLineTo(2.725f)
            verticalLineTo(7.045f)
            horizontalLineTo(2.497f)
            close()
            moveTo(5.683f, 7.553f)
            verticalLineTo(7.774f)
            horizontalLineTo(5.91f)
            verticalLineTo(7.553f)
            horizontalLineTo(5.683f)
            close()
            moveTo(5.683f, 7.409f)
            verticalLineTo(7.188f)
            horizontalLineTo(5.91f)
            verticalLineTo(7.409f)
            horizontalLineTo(5.683f)
            close()
            moveTo(5.683f, 6.824f)
            verticalLineTo(7.045f)
            horizontalLineTo(5.91f)
            verticalLineTo(6.824f)
            horizontalLineTo(5.683f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.611f, 6.428f)
            lineTo(3.23f, 6.76f)
            verticalLineTo(7.834f)
            lineTo(3.547f, 8.058f)
            horizontalLineTo(4.919f)
            lineTo(5.236f, 7.834f)
            verticalLineTo(6.76f)
            lineTo(4.879f, 6.428f)
            horizontalLineTo(3.611f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.252f, 6.873f)
            lineTo(3.792f, 7.266f)
            horizontalLineTo(4.252f)
            verticalLineTo(6.873f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE8AA00))) {
            moveTo(4.252f, 7.623f)
            lineTo(3.792f, 7.23f)
            horizontalLineTo(4.252f)
            verticalLineTo(7.623f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.212f, 6.873f)
            lineTo(4.672f, 7.266f)
            horizontalLineTo(4.212f)
            verticalLineTo(6.873f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.232f, 7.373f)
            curveTo(4.309f, 7.373f, 4.372f, 7.31f, 4.372f, 7.233f)
            curveTo(4.372f, 7.156f, 4.309f, 7.094f, 4.232f, 7.094f)
            curveTo(4.155f, 7.094f, 4.093f, 7.156f, 4.093f, 7.233f)
            curveTo(4.093f, 7.31f, 4.155f, 7.373f, 4.232f, 7.373f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE1E5E8))) {
            moveTo(4.212f, 7.623f)
            lineTo(4.672f, 7.23f)
            horizontalLineTo(4.212f)
            verticalLineTo(7.623f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.252f, 7.094f)
            horizontalLineTo(2.854f)
            verticalLineTo(7.221f)
            horizontalLineTo(3.252f)
            verticalLineTo(7.094f)
            close()
            moveTo(3.252f, 7.326f)
            horizontalLineTo(2.854f)
            verticalLineTo(7.454f)
            horizontalLineTo(3.252f)
            verticalLineTo(7.326f)
            close()
            moveTo(5.243f, 7.094f)
            horizontalLineTo(5.642f)
            verticalLineTo(7.221f)
            horizontalLineTo(5.243f)
            verticalLineTo(7.094f)
            close()
            moveTo(5.642f, 7.326f)
            horizontalLineTo(5.243f)
            verticalLineTo(7.454f)
            horizontalLineTo(5.642f)
            verticalLineTo(7.326f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.208f, 6.957f)
            horizontalLineTo(2.854f)
            verticalLineTo(7.096f)
            horizontalLineTo(3.208f)
            verticalLineTo(6.957f)
            close()
            moveTo(3.208f, 7.189f)
            horizontalLineTo(2.854f)
            verticalLineTo(7.329f)
            horizontalLineTo(3.208f)
            verticalLineTo(7.189f)
            close()
            moveTo(2.854f, 7.422f)
            horizontalLineTo(3.208f)
            verticalLineTo(7.561f)
            horizontalLineTo(2.854f)
            verticalLineTo(7.422f)
            close()
            moveTo(5.597f, 6.957f)
            horizontalLineTo(5.243f)
            verticalLineTo(7.096f)
            horizontalLineTo(5.597f)
            verticalLineTo(6.957f)
            close()
            moveTo(5.243f, 7.189f)
            horizontalLineTo(5.597f)
            verticalLineTo(7.329f)
            horizontalLineTo(5.243f)
            verticalLineTo(7.189f)
            close()
            moveTo(5.597f, 7.422f)
            horizontalLineTo(5.243f)
            verticalLineTo(7.561f)
            horizontalLineTo(5.597f)
            verticalLineTo(7.422f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.241f, 0.994f)
            lineTo(6.239f, 1.247f)
            horizontalLineTo(4.39f)
            lineTo(4.389f, 2.397f)
            horizontalLineTo(3.809f)
            curveTo(3.708f, 2.397f, 3.43f, 2.203f, 3.43f, 2.203f)
            horizontalLineTo(2.959f)
            lineTo(2.742f, 1.981f)
            verticalLineTo(1.758f)
            lineTo(2.508f, 1.481f)
            lineTo(2.51f, 1.227f)
            horizontalLineTo(4.359f)
            lineTo(4.36f, 0.077f)
            horizontalLineTo(4.94f)
            curveTo(5.042f, 0.077f, 5.319f, 0.272f, 5.319f, 0.272f)
            horizontalLineTo(5.79f)
            lineTo(6.007f, 0.494f)
            verticalLineTo(0.717f)
            lineTo(6.241f, 0.994f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.508f, 0.994f)
            lineTo(2.51f, 1.247f)
            horizontalLineTo(4.359f)
            lineTo(4.36f, 2.397f)
            horizontalLineTo(4.94f)
            curveTo(5.042f, 2.397f, 5.319f, 2.203f, 5.319f, 2.203f)
            horizontalLineTo(5.79f)
            lineTo(6.007f, 1.981f)
            verticalLineTo(1.758f)
            lineTo(6.241f, 1.481f)
            lineTo(6.239f, 1.227f)
            horizontalLineTo(4.39f)
            lineTo(4.389f, 0.077f)
            horizontalLineTo(3.809f)
            curveTo(3.708f, 0.077f, 3.43f, 0.272f, 3.43f, 0.272f)
            horizontalLineTo(2.959f)
            lineTo(2.742f, 0.494f)
            verticalLineTo(0.717f)
            lineTo(2.508f, 0.994f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.751f, 0.428f)
            lineTo(3.731f, 0.331f)
            lineTo(4.13f, 0.239f)
            curveTo(4.178f, 0.216f, 4.261f, 0.15f, 4.376f, 0.043f)
            lineTo(4.429f, 0.103f)
            lineTo(4.438f, 0.093f)
            curveTo(4.553f, 0.2f, 4.636f, 0.266f, 4.684f, 0.289f)
            lineTo(5.083f, 0.381f)
            lineTo(5.062f, 0.478f)
            lineTo(4.841f, 0.433f)
            lineTo(4.862f, 0.452f)
            curveTo(4.847f, 0.461f, 4.831f, 0.474f, 4.813f, 0.491f)
            lineTo(4.72f, 0.478f)
            lineTo(4.728f, 0.446f)
            lineTo(4.705f, 0.442f)
            curveTo(4.688f, 0.475f, 4.668f, 0.521f, 4.647f, 0.58f)
            lineTo(4.554f, 0.553f)
            lineTo(4.591f, 0.372f)
            lineTo(4.38f, 0.174f)
            lineTo(4.232f, 0.312f)
            curveTo(4.251f, 0.329f, 4.269f, 0.348f, 4.287f, 0.37f)
            curveTo(4.272f, 0.376f, 4.257f, 0.381f, 4.242f, 0.386f)
            lineTo(4.236f, 0.387f)
            lineTo(4.26f, 0.503f)
            lineTo(4.167f, 0.53f)
            curveTo(4.155f, 0.496f, 4.143f, 0.466f, 4.132f, 0.44f)
            lineTo(4.124f, 0.441f)
            curveTo(4.106f, 0.424f, 4.09f, 0.411f, 4.075f, 0.402f)
            lineTo(4.101f, 0.378f)
            curveTo(4.097f, 0.37f, 4.093f, 0.364f, 4.089f, 0.359f)
            lineTo(3.751f, 0.428f)
            close()
            moveTo(3.768f, 0.786f)
            lineTo(3.821f, 0.703f)
            lineTo(3.546f, 0.518f)
            lineTo(3.576f, 0.475f)
            lineTo(3.498f, 0.416f)
            lineTo(3.464f, 0.463f)
            lineTo(3.355f, 0.39f)
            lineTo(3.301f, 0.474f)
            lineTo(3.406f, 0.544f)
            lineTo(3.385f, 0.574f)
            lineTo(3.463f, 0.633f)
            lineTo(3.488f, 0.599f)
            lineTo(3.768f, 0.786f)
            close()
            moveTo(3.427f, 0.886f)
            lineTo(3.48f, 0.803f)
            lineTo(3.205f, 0.618f)
            lineTo(3.235f, 0.575f)
            lineTo(3.157f, 0.516f)
            lineTo(3.123f, 0.563f)
            lineTo(3.014f, 0.49f)
            lineTo(2.96f, 0.574f)
            lineTo(3.065f, 0.644f)
            lineTo(3.044f, 0.674f)
            lineTo(3.122f, 0.733f)
            lineTo(3.147f, 0.699f)
            lineTo(3.427f, 0.886f)
            close()
            moveTo(3.281f, 1.186f)
            lineTo(3.334f, 1.103f)
            lineTo(3.059f, 0.918f)
            lineTo(3.089f, 0.875f)
            lineTo(3.011f, 0.816f)
            lineTo(2.977f, 0.863f)
            lineTo(2.868f, 0.79f)
            lineTo(2.814f, 0.874f)
            lineTo(2.919f, 0.944f)
            lineTo(2.898f, 0.974f)
            lineTo(2.976f, 1.033f)
            lineTo(3.001f, 0.999f)
            lineTo(3.281f, 1.186f)
            close()
            moveTo(3.285f, 1.426f)
            lineTo(3.232f, 1.343f)
            lineTo(2.952f, 1.53f)
            lineTo(2.927f, 1.496f)
            lineTo(2.849f, 1.555f)
            lineTo(2.87f, 1.585f)
            lineTo(2.766f, 1.656f)
            lineTo(2.819f, 1.739f)
            lineTo(2.928f, 1.666f)
            lineTo(2.962f, 1.713f)
            lineTo(3.04f, 1.654f)
            lineTo(3.01f, 1.611f)
            lineTo(3.285f, 1.426f)
            close()
            moveTo(3.378f, 1.643f)
            lineTo(3.431f, 1.726f)
            lineTo(3.156f, 1.911f)
            lineTo(3.187f, 1.954f)
            lineTo(3.108f, 2.013f)
            lineTo(3.074f, 1.966f)
            lineTo(2.965f, 2.039f)
            lineTo(2.912f, 1.956f)
            lineTo(3.017f, 1.885f)
            lineTo(2.995f, 1.855f)
            lineTo(3.073f, 1.796f)
            lineTo(3.098f, 1.83f)
            lineTo(3.378f, 1.643f)
            close()
            moveTo(3.719f, 1.743f)
            lineTo(3.772f, 1.826f)
            lineTo(3.497f, 2.011f)
            lineTo(3.527f, 2.054f)
            lineTo(3.449f, 2.113f)
            lineTo(3.415f, 2.066f)
            lineTo(3.306f, 2.139f)
            lineTo(3.253f, 2.056f)
            lineTo(3.357f, 1.985f)
            lineTo(3.336f, 1.955f)
            lineTo(3.414f, 1.896f)
            lineTo(3.439f, 1.93f)
            lineTo(3.719f, 1.743f)
            close()
            moveTo(4.239f, 2.221f)
            curveTo(4.223f, 2.215f, 4.208f, 2.209f, 4.194f, 2.205f)
            lineTo(4.175f, 2.2f)
            lineTo(4.212f, 2.026f)
            lineTo(4.118f, 1.999f)
            curveTo(4.088f, 2.083f, 4.061f, 2.141f, 4.04f, 2.171f)
            lineTo(3.703f, 2.101f)
            lineTo(3.682f, 2.199f)
            lineTo(4.067f, 2.287f)
            lineTo(4.067f, 2.287f)
            lineTo(4.122f, 2.324f)
            lineTo(4.13f, 2.32f)
            curveTo(4.178f, 2.354f, 4.244f, 2.409f, 4.327f, 2.486f)
            lineTo(4.358f, 2.451f)
            lineTo(4.39f, 2.486f)
            curveTo(4.504f, 2.379f, 4.587f, 2.314f, 4.635f, 2.29f)
            lineTo(4.648f, 2.287f)
            curveTo(4.665f, 2.302f, 4.682f, 2.314f, 4.699f, 2.324f)
            lineTo(4.754f, 2.287f)
            lineTo(4.749f, 2.268f)
            lineTo(4.755f, 2.263f)
            lineTo(5.034f, 2.199f)
            lineTo(5.014f, 2.101f)
            lineTo(4.676f, 2.171f)
            curveTo(4.655f, 2.141f, 4.628f, 2.083f, 4.598f, 1.999f)
            lineTo(4.505f, 2.026f)
            lineTo(4.543f, 2.207f)
            lineTo(4.358f, 2.38f)
            lineTo(4.216f, 2.247f)
            curveTo(4.223f, 2.238f, 4.231f, 2.23f, 4.239f, 2.221f)
            close()
            moveTo(5.431f, 1.426f)
            lineTo(5.484f, 1.343f)
            lineTo(5.764f, 1.53f)
            lineTo(5.789f, 1.496f)
            lineTo(5.868f, 1.555f)
            lineTo(5.846f, 1.585f)
            lineTo(5.951f, 1.656f)
            lineTo(5.898f, 1.739f)
            lineTo(5.788f, 1.666f)
            lineTo(5.754f, 1.713f)
            lineTo(5.676f, 1.654f)
            lineTo(5.707f, 1.611f)
            lineTo(5.431f, 1.426f)
            close()
            moveTo(5.285f, 1.726f)
            lineTo(5.338f, 1.643f)
            lineTo(5.618f, 1.83f)
            lineTo(5.643f, 1.796f)
            lineTo(5.722f, 1.855f)
            lineTo(5.7f, 1.885f)
            lineTo(5.805f, 1.956f)
            lineTo(5.752f, 2.039f)
            lineTo(5.642f, 1.966f)
            lineTo(5.608f, 2.013f)
            lineTo(5.53f, 1.954f)
            lineTo(5.561f, 1.911f)
            lineTo(5.285f, 1.726f)
            close()
            moveTo(4.944f, 1.826f)
            lineTo(4.997f, 1.743f)
            lineTo(5.277f, 1.93f)
            lineTo(5.302f, 1.896f)
            lineTo(5.381f, 1.955f)
            lineTo(5.359f, 1.985f)
            lineTo(5.464f, 2.056f)
            lineTo(5.411f, 2.139f)
            lineTo(5.301f, 2.066f)
            lineTo(5.267f, 2.113f)
            lineTo(5.189f, 2.054f)
            lineTo(5.22f, 2.011f)
            lineTo(4.944f, 1.826f)
            close()
            moveTo(5.48f, 1.153f)
            lineTo(5.533f, 1.236f)
            lineTo(5.813f, 1.049f)
            lineTo(5.838f, 1.083f)
            lineTo(5.916f, 1.024f)
            lineTo(5.895f, 0.994f)
            lineTo(6f, 0.924f)
            lineTo(5.946f, 0.84f)
            lineTo(5.837f, 0.913f)
            lineTo(5.803f, 0.866f)
            lineTo(5.725f, 0.925f)
            lineTo(5.755f, 0.968f)
            lineTo(5.48f, 1.153f)
            close()
            moveTo(5.334f, 0.853f)
            lineTo(5.387f, 0.936f)
            lineTo(5.667f, 0.749f)
            lineTo(5.692f, 0.783f)
            lineTo(5.77f, 0.724f)
            lineTo(5.749f, 0.694f)
            lineTo(5.853f, 0.624f)
            lineTo(5.8f, 0.54f)
            lineTo(5.691f, 0.613f)
            lineTo(5.657f, 0.566f)
            lineTo(5.579f, 0.625f)
            lineTo(5.609f, 0.668f)
            lineTo(5.334f, 0.853f)
            close()
            moveTo(4.993f, 0.753f)
            lineTo(5.046f, 0.836f)
            lineTo(5.326f, 0.649f)
            lineTo(5.351f, 0.683f)
            lineTo(5.429f, 0.624f)
            lineTo(5.408f, 0.594f)
            lineTo(5.513f, 0.524f)
            lineTo(5.459f, 0.44f)
            lineTo(5.35f, 0.513f)
            lineTo(5.316f, 0.466f)
            lineTo(5.238f, 0.525f)
            lineTo(5.268f, 0.568f)
            lineTo(4.993f, 0.753f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.88f, 0.721f)
            lineTo(4.431f, 0.428f)
            verticalLineTo(1.228f)
            horizontalLineTo(5.795f)
            lineTo(5.47f, 1.462f)
            verticalLineTo(1.768f)
            horizontalLineTo(4.956f)
            lineTo(4.404f, 2.061f)
            verticalLineTo(1.261f)
            horizontalLineTo(3.041f)
            lineTo(3.365f, 1.027f)
            verticalLineTo(0.721f)
            horizontalLineTo(3.88f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.956f, 0.721f)
            lineTo(4.404f, 0.428f)
            verticalLineTo(1.228f)
            horizontalLineTo(3.041f)
            lineTo(3.365f, 1.462f)
            verticalLineTo(1.768f)
            horizontalLineTo(3.88f)
            lineTo(4.431f, 2.061f)
            verticalLineTo(1.261f)
            horizontalLineTo(5.795f)
            lineTo(5.47f, 1.027f)
            verticalLineTo(0.721f)
            horizontalLineTo(4.956f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.612f, 0.928f)
            lineTo(3.702f, 0.751f)
            lineTo(3.931f, 0.873f)
            lineTo(3.994f, 0.779f)
            lineTo(4.154f, 0.893f)
            lineTo(4.105f, 0.966f)
            lineTo(4.783f, 1.329f)
            lineTo(4.824f, 1.266f)
            lineTo(4.985f, 1.38f)
            lineTo(4.957f, 1.422f)
            lineTo(5.03f, 1.461f)
            lineTo(4.94f, 1.638f)
            lineTo(4.845f, 1.588f)
            lineTo(4.768f, 1.702f)
            lineTo(4.608f, 1.588f)
            lineTo(4.671f, 1.494f)
            lineTo(3.993f, 1.132f)
            lineTo(3.938f, 1.215f)
            lineTo(3.777f, 1.101f)
            lineTo(3.819f, 1.039f)
            lineTo(3.612f, 0.928f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.056f, 0.879f)
            lineTo(4.954f, 0.708f)
            lineTo(4.734f, 0.847f)
            lineTo(4.665f, 0.757f)
            lineTo(4.513f, 0.882f)
            lineTo(4.567f, 0.952f)
            lineTo(3.916f, 1.361f)
            lineTo(3.87f, 1.301f)
            lineTo(3.718f, 1.426f)
            lineTo(3.749f, 1.466f)
            lineTo(3.679f, 1.51f)
            lineTo(3.781f, 1.68f)
            lineTo(3.872f, 1.623f)
            lineTo(3.956f, 1.732f)
            lineTo(4.108f, 1.607f)
            lineTo(4.039f, 1.518f)
            lineTo(4.69f, 1.109f)
            lineTo(4.751f, 1.188f)
            lineTo(4.903f, 1.063f)
            lineTo(4.857f, 1.004f)
            lineTo(5.056f, 0.879f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(11.921f, 1.25f)
            curveTo(11.921f, 1.25f, 13.377f, 4.701f, 12.083f, 6.167f)
            curveTo(10.789f, 7.632f, 7.5f, 7.35f, 7.5f, 7.35f)
            curveTo(7.5f, 7.35f, 11.723f, 9.257f, 13.563f, 6.631f)
            curveTo(15.402f, 4.004f, 11.921f, 1.25f, 11.921f, 1.25f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(9.278f, 3.28f)
            lineTo(8.892f, 3.552f)
            lineTo(9.028f, 3.097f)
            lineTo(8.654f, 2.81f)
            lineTo(9.124f, 2.8f)
            lineTo(9.278f, 2.352f)
            lineTo(9.432f, 2.8f)
            lineTo(9.901f, 2.81f)
            lineTo(9.527f, 3.097f)
            lineTo(9.663f, 3.552f)
            lineTo(9.278f, 3.28f)
            close()
            moveTo(9.352f, 4.534f)
            lineTo(8.967f, 4.805f)
            lineTo(9.103f, 4.35f)
            lineTo(8.729f, 4.063f)
            lineTo(9.198f, 4.054f)
            lineTo(9.352f, 3.605f)
            lineTo(9.506f, 4.054f)
            lineTo(9.976f, 4.063f)
            lineTo(9.602f, 4.35f)
            lineTo(9.738f, 4.805f)
            lineTo(9.352f, 4.534f)
            close()
            moveTo(7.795f, 4.902f)
            lineTo(8.181f, 4.63f)
            lineTo(8.566f, 4.902f)
            lineTo(8.43f, 4.447f)
            lineTo(8.804f, 4.16f)
            lineTo(8.335f, 4.151f)
            lineTo(8.181f, 3.702f)
            lineTo(8.027f, 4.151f)
            lineTo(7.557f, 4.16f)
            lineTo(7.931f, 4.447f)
            lineTo(7.795f, 4.902f)
            close()
            moveTo(9.352f, 5.848f)
            lineTo(8.967f, 6.12f)
            lineTo(9.103f, 5.665f)
            lineTo(8.729f, 5.378f)
            lineTo(9.198f, 5.368f)
            lineTo(9.352f, 4.92f)
            lineTo(9.506f, 5.368f)
            lineTo(9.976f, 5.378f)
            lineTo(9.602f, 5.665f)
            lineTo(9.738f, 6.12f)
            lineTo(9.352f, 5.848f)
            close()
            moveTo(10.24f, 4.422f)
            lineTo(10.626f, 4.151f)
            lineTo(11.011f, 4.422f)
            lineTo(10.875f, 3.967f)
            lineTo(11.249f, 3.68f)
            lineTo(10.78f, 3.671f)
            lineTo(10.626f, 3.222f)
            lineTo(10.472f, 3.671f)
            lineTo(10.002f, 3.68f)
            lineTo(10.376f, 3.967f)
            lineTo(10.24f, 4.422f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun TurkmenistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Turkmenistan,
            contentDescription = "Turkmenistan Flag"
        )
    }
}
